import { type FC, useRef, useEffect } from 'react';

import lottie from 'lottie-web/build/player/lottie_light';
import { v4 as uuidv4 } from 'uuid';

import orangeSpinner from './assets/compass_preloader.json';
import defaultSpinner from './assets/compass_spinner_grey.json';
import { useStyles } from './CompassLoader.style';

const animationElementSize = { md: { width: '48px', height: '48px' }, lg: { width: '96px', height: '96px' } };
const animationNamePrefix = 'CompassLoader';

type CompassLoaderProps = {
	size?: keyof typeof animationElementSize;
	type?: 'default' | 'orange';
	paddingContainer?: boolean;
};

export const CompassLoader: FC<CompassLoaderProps> = ({ size = 'md', type, paddingContainer = true }) => {
	const { classes, cx } = useStyles();
	const animationElement = useRef<HTMLDivElement>(null);
	const animationName = `${animationNamePrefix}-${uuidv4()}`;

	useEffect(() => {
		if (animationElement.current)
			lottie.loadAnimation({
				loop: true,
				autoplay: true,
				animationData: type === 'orange' ? orangeSpinner : defaultSpinner,
				rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
				container: animationElement.current,
				name: animationName,
			});

		return (): void => {
			lottie.stop(animationName);
			lottie.destroy(animationName);
		};
	}, [type, animationName]);

	return (
		<div className={cx(classes.container, paddingContainer && classes.paddingContainer)}>
			<div ref={animationElement} style={animationElementSize[size]} />
		</div>
	);
};
